import React, { useEffect, useState } from "react";
import { sent_Request,DeleteRequest } from "../../apis/api/FreightRerquestApi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie"
import SentRequestView from "../../Models/Freight_RequestModel/Sent_requestViewModel";
import Lodderr from "../Lodder/Lodder";
import CustomTableWrapper from "../../Hooks/CustomTableWrapper";
import ConfirmModal from "../../Hooks/ConfirmModal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const SentRequest = () => {

  const [showModel, setshowModel] = useState();
  const [propsData, setpropsData] = useState();
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const userId = Cookies.get("userID")
    dispatch(sent_Request({ id: userId }))
  }, [showConfirmModel]);
  const { sentRequest } = useSelector((state) => state.FreightRequest)
  console.log(sentRequest,"sentRequest");
  const handleShowModal = (data) => {
    setpropsData(data);
    setshowModel(true);
  };

  const deleteHandler =async () => {
   
    const response=await dispatch(DeleteRequest({id:selectedItem.id}))
    if(response.payload.status=='success'){
      setShowConfirmModel(false)
      navigate('/sent_request')
      toast.success(response.payload.message);

    }else if(response.payload.status=='error'){
      toast.error(response.payload.message);
    }else{
      toast.error('Error');
    }
    
  };


  const { loading } = useSelector((state) => state.FreightRequest)
  return (
    <>
      {loading && <Lodderr />}
      <SentRequestView show={showModel} handleClose={() => setshowModel(false)} data={propsData} />

      <ConfirmModal
        isOpen={showConfirmModel}
        onConfirm={deleteHandler}
        onCancel={() => setShowConfirmModel(false)}
        message="Are you sure you want to Delete this request?"
      />

      <CustomTableWrapper
        data={sentRequest}
        itemsPerPage={10}
        enableSearch={true}
        searchKeys={["random_id", "member_names", "created_at"]}
        columns={[
          { label: "Request ID", field: "random_id", sortable: true },
          { label: "Member Names", field: "member_names", sortable: true },
          { label: "Entry Date", field: "created_at", sortable: true },
          { label: "Action", field: "action" },
        ]}
        renderRow={(item, index, currentPage, itemsPerPage) => (
          <tr key={index}>
            <td>{item.random_id}</td>
            <td>{item.member_names}</td>
            <td>
              {
                (() => {
                  const date = new Date(item.created_at * 1000);
                  return date.toLocaleDateString('en-US', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  }); 
                })()
              }
            </td>
            <td>
            <div class="d-flex justify-content-center align-items-center gap-2 flex-wrap" >
            <button onClick={() => handleShowModal(item)} className="btn btn-sm btn-warning waves-effect waves-light text-light" to="/request_view" data-bs-toggle="modal" data-bs-target="#form-modal" >  <i class='bx bx-show'></i>
            </button>

            <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => {
                    setSelectedItem(item);
                    setShowConfirmModel(true);
                  }}
            >
            <i class="bx bxs-trash"></i>
            </button>
          
            </div>

            
         



            </td>
          </tr>
        )}
      />


     
    
    </>
  );
};

export default SentRequest;
